import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import '@enamelai/design-system/styles.css'
import './styles/design-system-overrides.css'
import '@components/ui/tokens/colors.css'
import App from './App'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { store } from '@store/index'
import { registerLicense } from '@syncfusion/ej2-base'
import { GlobalLoadingProvider } from '@context/GlobalLoadingContext'
import { FileSelectionForClaimProcedureProvider } from '@context/FileSelectionForClaimProcedureContext'
import { suppressResizeObserverError } from '@utils/suppressResizeObserverError'
import { ErrorBoundary } from '@components/common/ErrorBoundary'
import { ThemeProvider } from '@context/ThemeContext'

suppressResizeObserverError()

// Registering Syncfusion license key
registerLicense(
  'ORg4AjUWIQA/Gnt2UVhhQlVFfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX5QdEVhWXxbdXdcRGFV',
)
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <ErrorBoundary variant="root">
          <ThemeProvider>
            <GlobalLoadingProvider>
              <FileSelectionForClaimProcedureProvider>
                <App />
              </FileSelectionForClaimProcedureProvider>
            </GlobalLoadingProvider>
          </ThemeProvider>
        </ErrorBoundary>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
)
